<template>
    <b-form-group class="mb-0">
        <b-input-group size="sm">
            <b-form-input
                v-model="localSearch"
                placeholder="Entrer la valeur recherchée"
                @update="setSearch(localSearch)"
            />
            <b-input-group-append>
                <b-button :disabled="!localSearch" @click="resetSearch"
                    >Effacer</b-button
                >
            </b-input-group-append>
        </b-input-group>
    </b-form-group>
</template>

<script>
import { mapState } from 'vuex'
import TableHandler from '../../../common/mixins/TableHandler'

export default {
    name: 'SearchFilter',

    mixins: [TableHandler],

    data() {
        return {
            localSearch: null,
        }
    },

    created() {
        this.localSearch = this.search
    },

    computed: {
        ...mapState({
            search: (state) => state.reportingVM.search,
        }),
    },
}
</script>

<style scoped></style>
